import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { getEvent } from '../config/events';
import '../assets/css/PhotoGallery.css';

// Youth bootcamp images
import previewEvent1 from '../assets/images/youth-bootcamp/preview-event-1.jpg';
import previewEvent2 from '../assets/images/youth-bootcamp/preview-event-2.jpg';
import previewEvent3 from '../assets/images/youth-bootcamp/preview-event-3.jpg';
import previewEvent4 from '../assets/images/youth-bootcamp/preview-event-4.jpg';
import previewEvent5 from '../assets/images/youth-bootcamp/preview-event-5.jpg';

// Women of Noble Character images
import wnc7059 from '../assets/images/women-of-noble-character/wnc-7059.jpg';
import wnc7061 from '../assets/images/women-of-noble-character/wnc-7061.jpg';
import wnc7064 from '../assets/images/women-of-noble-character/wnc-7064.jpg';
import wnc7066 from '../assets/images/women-of-noble-character/wnc-7066.jpg';
import wnc7067 from '../assets/images/women-of-noble-character/wnc-7067.jpg';
import wnc7068 from '../assets/images/women-of-noble-character/wnc-7068.jpg';
import wnc7070 from '../assets/images/women-of-noble-character/wnc-7070.jpg';
import wnc7072 from '../assets/images/women-of-noble-character/wnc-7072.jpg';
import wnc7073 from '../assets/images/women-of-noble-character/wnc-7073.jpg';
import wnc7074 from '../assets/images/women-of-noble-character/wnc-7074.jpg';
import wnc2 from '../assets/images/women-of-noble-character/wnc2.jpg';

const imageMap = {
  'youth-bootcamp/preview-event-1.jpg': previewEvent1,
  'youth-bootcamp/preview-event-2.jpg': previewEvent2,
  'youth-bootcamp/preview-event-3.jpg': previewEvent3,
  'youth-bootcamp/preview-event-4.jpg': previewEvent4,
  'youth-bootcamp/preview-event-5.jpg': previewEvent5,
  'women-of-noble-character/wnc-7059.jpg': wnc7059,
  'women-of-noble-character/wnc-7061.jpg': wnc7061,
  'women-of-noble-character/wnc-7064.jpg': wnc7064,
  'women-of-noble-character/wnc-7066.jpg': wnc7066,
  'women-of-noble-character/wnc-7067.jpg': wnc7067,
  'women-of-noble-character/wnc-7068.jpg': wnc7068,
  'women-of-noble-character/wnc-7070.jpg': wnc7070,
  'women-of-noble-character/wnc-7072.jpg': wnc7072,
  'women-of-noble-character/wnc-7073.jpg': wnc7073,
  'women-of-noble-character/wnc-7074.jpg': wnc7074,
  'women-of-noble-character/wnc2.jpg': wnc2,
};

const PhotoGallery = ({ eventId: propEventId }) => {
  const [searchParams] = useSearchParams();
  const eventId = propEventId || searchParams.get('event') || 'youth-bootcamp';
  const event = getEvent(eventId);

  if (!event?.images?.gallery || event.images.gallery.length === 0) {
    return null;
  }

  const images = event.images.gallery.map((src, index) => ({
    id: index + 1,
    src: imageMap[src],
    alt: `${event.title} event photo ${index + 1}`
  }));

  return (
    <section className="photo-gallery py-5 bg-light">
      <Container>
        <h2 className="text-center fw-bold mb-4">PREVIOUS EVENTS</h2>
        <p className="text-center mb-5">Check out the amazing moments from our previous events!</p>
        
        <div className="gallery-container">
          <Row className="g-4">
            {images.map(image => (
              <Col xs={12} sm={6} key={image.id}>
                <div className="gallery-item">
                  <img 
                    src={image.src} 
                    alt={image.alt} 
                    className="img-fluid rounded shadow-sm" 
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default PhotoGallery;
